<div class="row align-top gutters">
  <div class="col-md-6">
    <div [ngClass]="permissions.projectDetailPermissions._edit ? 'subsection-header-with-button' : 'subsection-header'"  class="gray">
      @if (permissions.projectDetailPermissions._edit) {
        <span></span>
      }
      Acquisitions Notes
      @if (permissions.projectDetailPermissions._edit) {
        <span class="save-icon">
          <button mat-mini-fab (click)="toggleAcqNotesEditMode()">
            @if (!acqNotesEditMode) {
              <mat-icon>edit</mat-icon>
            }
            @if (acqNotesEditMode) {
              <mat-icon>save</mat-icon>
            }
          </button>
        </span>
      }
    </div>
    @if (!permissions.projectDetailPermissions._edit || !acqNotesEditMode) {
      <div>
        @if (acquisitions) {
          <div class="notes-read-only">{{acquisitions}}</div>
        }
        @if (!acquisitions) {
          <em>There are no Acquisitions notes for this deal.</em>
        }
      </div>
    }

    @if (permissions.projectDetailPermissions._edit && acqNotesEditMode) {
      <form>
        <mat-form-field>
          <mat-label>Type Acquisition notes here</mat-label>
          <textarea matInput
            [formControl]="acq"
          (change)="acqChanged=true"></textarea>
        </mat-form-field>
      </form>
    }
  </div>

  <div class="col-md-6">
    <div [ngClass]="permissions.projectCreditOutletPermissions._edit ? 'subsection-header-with-button' : 'subsection-header'"  class="gray">
      @if (permissions.projectCreditOutletPermissions._edit) {
        <span></span>
      }
      Syndications Notes
      @if (permissions.projectCreditOutletPermissions._edit) {
        <span class="save-icon">
          <button mat-mini-fab (click)="toggleSyndNotesEditMode()">
            @if (!syndNotesEditMode) {
              <mat-icon>edit</mat-icon>
            }
            @if (syndNotesEditMode) {
              <mat-icon>save</mat-icon>
            }
          </button>
        </span>
      }
    </div>
    @if (!permissions.projectCreditOutletPermissions._edit || !syndNotesEditMode) {
      <div>
        @if (syndications) {
          <div class="notes-read-only">{{syndications}}</div>
        }
        @if (!syndications) {
          <em>There are no Syndications notes for this deal.</em>
        }
      </div>
    }

    @if (permissions.projectCreditOutletPermissions._edit && syndNotesEditMode) {
      <form>
        <mat-form-field>
          <mat-label>Type Syndications notes here</mat-label>
          <textarea matInput
            [formControl]="synd"
          (change)="syndChanged=true"></textarea>
        </mat-form-field>
      </form>
    }
  </div>

</div>
